import { Pipe, PipeTransform } from '@angular/core';

import { RdsChip } from '../chips/index';
import { getRdsDateFilterIso, RdsDateFilter } from '../core/models/filter/date-filter.model';

/**
 * Turn `RdsDateFilter` into RdsChips
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsDateFiltersToChips',
})
export class RdsDateFiltersToChipsPipe implements PipeTransform {
  transform(value: Array<RdsDateFilter>): Array<RdsChip> {
    if (!value || !value.length) {
      return [];
    }
    return value.map((f) => {
      const iso: string = getRdsDateFilterIso(f);
      return new RdsChip(f.operation.type + ' ' + iso, f.operation.type + f.value.valueOf());
    });
  }
}
